export default {
  DATE: "DD.MM.YYYY",
  DATETIME: "DD.MM.YYYY H:mm:ss",
  MONTH: "YYYY-MM",
  TIME: "H:mm:ss",
  SERVER: "YYYY-MM-DD HH:mm:ss",
  SIMPLETIME: "HH:mm",
  SIMPLEDATETIME: "DD.MM. HH:mm",
  DEFAULT: "YYYY-MM-DD",
  WEEK: "YYYY-[W]WW",
  YM: "YYYY/M",
  YEAR: "YYYY",
}